import { useState } from "react";
import { Link } from "react-router-dom";
import DRLogo from "../MyImages/DRLogo.png";
import { contractApiEndpoint } from "../utils/contractApi";
import "./contract-signing.css";

const emptyInvite = {
  participantName: "",
  participantEmail: "",
  instrument: "",
};

const instruments = [
  ["violin_i", "Violin I"], ["violin_ii", "Violin II"], ["viola", "Viola"],
  ["cello", "Cello"], ["bass", "Bass"], ["bassoon", "Bassoon"],
  ["clarinet", "Clarinet"], ["flute", "Flute"], ["french_horn", "French Horn"],
  ["oboe", "Oboe"], ["saxophone", "Saxophone"], ["trombone", "Trombone"],
  ["trumpet", "Trumpet"], ["tuba", "Tuba"], ["guitar", "Guitar"],
  ["percussion", "Percussion"], ["piano", "Piano"], ["vocal", "Vocal"],
];

export default function ContractInvites() {
  const [code, setCode] = useState("");
  const [adminToken, setAdminToken] = useState("");
  const [invite, setInvite] = useState(emptyInvite);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(null);

  const unlock = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const response = await fetch(contractApiEndpoint("openContractAdmin"), {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ code }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.error || "No se pudo validar el acceso.");
      setAdminToken(payload.adminToken);
      setCode("");
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  };

  const sendInvite = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const response = await fetch(contractApiEndpoint("createContractInvite"), {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ adminToken, ...invite }),
      });
      const payload = await response.json().catch(() => ({}));
      if (response.status === 401) setAdminToken("");
      if (!response.ok) throw new Error(payload.error || "No se pudo enviar la invitación.");
      setSent(payload);
      setInvite(emptyInvite);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="contract-page invite-admin-page">
      <div className="contract-glow contract-glow-one" />
      <div className="contract-glow contract-glow-two" />
      <header className="contract-topbar">
        <Link to="/" className="contract-brand">
          <img src={DRLogo} alt="SIMANOF Festival República Dominicana" />
          <span><strong>SIMANOF</strong><small>Invitaciones de firma</small></span>
        </Link>
        <div className="secure-pill"><span>✓</span> Área administrativa</div>
      </header>

      <section className="admin-shell">
        {!adminToken ? (
          <form className="admin-card access-card" onSubmit={unlock}>
            <p className="eyebrow">ACCESO RESTRINGIDO</p>
            <h1>Enviar contratos de forma privada.</h1>
            <p>Ingresa el código administrativo para crear enlaces personales de firma.</p>
            <label className="form-field">
              <span>Código de acceso</span>
              <input
                type="password"
                inputMode="numeric"
                value={code}
                onChange={(event) => setCode(event.target.value)}
                autoComplete="one-time-code"
                maxLength={12}
                autoFocus
              />
            </label>
            {error && <div className="form-error" role="alert">{error}</div>}
            <button className="submit-contract" disabled={busy || !code}>
              {busy ? <><span className="spinner" /> Verificando</> : <>Entrar <span>→</span></>}
            </button>
          </form>
        ) : (
          <form className="admin-card invite-card" onSubmit={sendInvite}>
            <div className="admin-card-heading">
              <div>
                <p className="eyebrow">NUEVA INVITACIÓN</p>
                <h1>Enviar contrato para firma.</h1>
              </div>
              <button type="button" className="text-button" onClick={() => setAdminToken("")}>Cerrar sesión</button>
            </div>
            <p className="admin-intro">Ingresa el nombre, correo e instrumento. El participante recibirá un enlace privado para firmar y, al finalizar, la copia firmada se enviará a su correo y a SIMANOF.</p>
            <div className="field-grid">
              <label className="form-field full">
                <span>Nombre completo del participante</span>
                <input required value={invite.participantName} onChange={(event) => setInvite({ ...invite, participantName: event.target.value })} placeholder="Nombre y apellido" />
              </label>
              <label className="form-field full">
                <span>Correo del participante</span>
                <input required type="email" value={invite.participantEmail} onChange={(event) => setInvite({ ...invite, participantEmail: event.target.value })} placeholder="participante@correo.com" />
              </label>
              <label className="form-field full">
                <span>Instrumento del participante</span>
                <select required value={invite.instrument} onChange={(event) => setInvite({ ...invite, instrument: event.target.value })}>
                  <option value="">Selecciona un instrumento</option>
                  {instruments.map(([value, label]) => <option value={value} key={value}>{label}</option>)}
                </select>
                <small>El sistema enviará automáticamente Orchestra, Ensemble o Jazz Combo, y Technique.</small>
              </label>
            </div>
            {sent && (
              <div className="invite-success" role="status">
                <strong>Invitación enviada</strong>
                <span>{sent.participantName} · {sent.participantEmail}</span>
              </div>
            )}
            {error && <div className="form-error" role="alert">{error}</div>}
            <button className="submit-contract" disabled={busy}>
              {busy ? <><span className="spinner" /> Enviando</> : <>Enviar invitación privada <span>→</span></>}
            </button>
          </form>
        )}
      </section>
    </main>
  );
}
